<template> 
     <div :class="me">       
           <p v-html="data.Text"></p>     
     </div>
</template>

<script>
import Global from "@/components/Global";
export default {
  name: "StickerMessage",
  props: ["data"],
  computed: {
    me() {
      let result = false;

      if (Global.current_staffid === this.data.frmId) {
        result = true;
      }
      return result
        ? "message other-message float-right"
        : "message my-message";
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/StickerMessage.vue